import React from 'react';
import { useCurrentModule } from '../components';
export const useDowngradeModalCallbacks = () => {
  const module = useCurrentModule();
  const {
    bi
  } = module.internals;
  return React.useMemo(() => ({
    onShow: props => {
      bi.onDowngradeModalLoad == null || bi.onDowngradeModalLoad(props);
    },
    onClose: props => {
      bi.onDowngradeModalClose == null || bi.onDowngradeModalClose(props);
    },
    onPrimaryButtonClick: props => {
      bi.onDowngradeSubmit == null || bi.onDowngradeSubmit({
        downgradeType: props.downgradeType,
        cycle: props.cycle,
        newCycle: props.newCycle
      });
    },
    onLinkClick: props => {
      bi.onDowngradeModalLinkClick == null || bi.onDowngradeModalLinkClick(props);
    },
    errorCallbacks: {
      onShow: _ref => {
        let {
          errorType,
          error
        } = _ref;
        bi.onDowngradeErrorModalLoad == null || bi.onDowngradeErrorModalLoad({
          errorType,
          errorMessage: error instanceof Error ? `${error.message} ${error.stack}` : 'Unknown error'
        });
      },
      onClose: props => {
        bi.onDowngradeErrorModalClose == null || bi.onDowngradeErrorModalClose(props);
      },
      onClick: _ref2 => {
        let {
          action
        } = _ref2;
        bi.onDowngradeErrorModalClick == null || bi.onDowngradeErrorModalClick({
          action
        });
      }
    },
    successCallbacks: {
      onShow: () => {
        bi.onDowngradeSuccessModalLoad == null || bi.onDowngradeSuccessModalLoad({});
      },
      onClick: _ref3 => {
        let {
          action,
          data
        } = _ref3;
        bi.onDowngradeSuccessModalClick == null || bi.onDowngradeSuccessModalClick({
          action,
          url: (data == null ? void 0 : data.url) ?? ''
        });
      }
    }
  }), [bi]);
};
//# sourceMappingURL=useDowngradeModalCallbacks.js.map